import React, { Fragment, h } from "preact";
import './Table.scss';

export default function TableCell ({children, className}) {
    const classNameStyle = className ? className : 'default'

    return (
        <div className={`component-table__cell ${classNameStyle}`}>
            {children}
        </div>
    )
}